export default __webpack_public_path__ + "static/media/36I-102770_-15880_0.9ff02022.jpg";